import * as Yup from 'yup';

export const getValidationSchema = (planDetails: any) => {
  return Yup.object().shape({
    name: Yup.string().required("Plan Name is required"),
    cost: !planDetails ? Yup.number().required("Price is required") : Yup.number(),

    chargeCycle: Yup.string().required("Charge Cycle is required"),
    storyCreationLimit: Yup.number()
      .when("freePhysicalBookStatus", {
        is: false,
        then: (schema) =>
          schema
            .min(1, "Story Creation Limit must be at least 1")
            .required("Story Creation Limit is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    imageCredits: Yup.number().required("Image Credits is required"),
    additionalImageCredits: Yup.number().required("Additional Image Credits is required"),
    additionalImageCreditsCost: Yup.number().required("Additional Image Credits Cost is required"),
    maxBookPage: Yup.number().required("Maxiumum Book Page is required"),
    modeCharacterGeneration: Yup.string().required("Character Generation Mode is required"),
    modeIllustrationGeneration: Yup.string().required("Illustration Generation Mode is required"),
    maintenanceMode: Yup.mixed().required("Maintenance Mode is required"),

    freePhysicalBookStatus: Yup.mixed()
      .oneOf([true, false], "Physical Book status must be true or false")
      .required("Physical Book status is required"),

    freePhysicalBookQuantity: Yup.number()
      .integer("Quantity must be an integer")
      .when("freePhysicalBookStatus", {
        is: true,
        then: (schema) =>
          schema
            .required("Quantity is required when Physical Book status is true")
            .moreThan(0, "Quantity must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
    mics: Yup.string(),
  });
};
